<h2 mat-dialog-title>{{'userGroups.title' | translate}}</h2>

<mat-dialog-content class="custom-width">
    <div class="pt-2 pb-3">
        <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
            <form [formGroup]="userGroupForm">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'userGroups.displayName' | translate}}</mat-label>
                    <input matInput type="text" formControlName="displayName" placeholder="{{'taskTemplateGropus.new_title' | translate}}" required >
                </mat-form-field>
            </form> 
        </section>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" >{{'cancel' | translate}}</button>
    
    <button mat-button class="orange-button" (click)="onSave();">
        @if(option=='edit'){  {{'save' | translate}}  }
        @else{  {{'taskTemplateGropus.create' | translate}}  }
    </button>
</mat-dialog-actions>